import { CheckOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './FeaturesSection.module.scss'

const FeaturesSection: React.FC = () => {
    const { t } = useTranslation()
    const features: string[] = t('features.list', { returnObjects: true })

    return (
        <PageSection
            title={t('features.title')}
            align="start"
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <ul className={cls.list}>
                {features.map((item, index) => (
                    <li key={index} className={cls.item}>
                        <span className={cls.check} aria-hidden>
                            <CheckOutlined />
                        </span>
                        {item}
                    </li>
                ))}
            </ul>
        </PageSection>
    )
}

export default FeaturesSection
